import React, { useContext, useState } from 'react';
import { Formik, Form } from 'formik';
import { useNavigate } from 'react-router-dom';
import { AppContext } from '../AppContext';
import { Link } from 'react-router-dom';
import ThemeSwitcher from './Theme';
import { getScreens } from './Elements';

const Colors: React.FC = () => {
  const navigate = useNavigate();
  const context = useContext(AppContext);

  if (!context) {
    throw new Error('Step5 must be used within an AppProvider');
  }

  const { appData, updateAppData } = context;
  const [appBarPreview, setAppBarPreview] = useState(appData.appBarLogo || 'https://build.zas.media/images/appbar.png');
  const [logoPreview, setLogoPreview] = useState(appData.logo || 'https://build.zas.media/images/logo.png');
  const [radioLogoPreview, setRadioLogoPreview] = useState(appData.radioLogo || 'https://build.zas.media/images/logo.png');

  const initialValues = {
    logo: appData.logo || '',
    appBarLogo: appData.appBarLogo || '',
    radioLogo: appData.radioLogo || '',
  };

  const screens = getScreens(appBarPreview, radioLogoPreview, logoPreview);

  return (
    <div className="container">
      <div className="flex gap-4">
        <div className="w-2/8 content col" style={{ maxWidth: '350px' }}>
          <Formik
            initialValues={initialValues}
            onSubmit={(values) => {
              updateAppData(values);
              navigate(`/${appData.id}/inicial`);
            }}
          >
            {({ setFieldValue }) => (
              <Form className='h-full'>
                <div className='flex flex-col h-full justify-between'>
                  <div>
                    <p className="font-semibold tracking-tight text-pretty text-gray-900 sm:text-2xl lg:text-balance">
                      Cores
                    </p>
                    <ThemeSwitcher></ThemeSwitcher>
                    <div className="bg-blue-100 border-t border-b border-blue-500 text-blue-700 px-4 py-3 mt-6" role="alert">
                      <p className="text-sm">Use a barra de rolagem inferior para visualizar todas as telas e conferir distribuição das cores em todo o app.</p>
                    </div>
                  </div>
                  <div className="flex justify-between mt-6">
                    <Link
                      to={`/${appData.id}/logo`}
                      className="bg-primary text-white px-6 py-3 text-xl rounded-md flex items-center space-x-2"
                    >
                      <i className="fas fa-arrow-left"></i>
                    </Link>
                    <button
                      type="submit"
                      className="bg-primary text-white px-6 py-3 text-xl rounded-md flex items-center space-x-2"
                    >
                      <span>Tela Inicial</span>
                      <i className="fas fa-arrow-right"></i>
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="w-4/5 relative">
          <svg fill="none" className="dash"><defs><pattern x="0" y="0" id="pattern-dfa52911-fec3-4817-ac8e-19f444cb2809" width="10" height="10" patternUnits="userSpaceOnUse"><path d="M-3 13 15-5M-5 5l18-18M-1 21 17 3"></path></pattern></defs><rect fill="url(#pattern-dfa52911-fec3-4817-ac8e-19f444cb2809)" width="100%" height="100%" stroke="none"></rect></svg>
          <div className='dash-over w-full p-4'>
            <div className='horizontal'>
              {screens.home()}
              {/* Exibir radio se appData.type NÃO for "web-church-tv", "web-church" ou "web-tv" */}
              {!["web-church-tv", "web-church", "web-tv"].includes(appData.type ?? '') && screens.radio()}
              {/* Exibir tv se appData.type for "web-tv-radio", "web-tv", "web-church-tv" ou "web-church-tv-radio" */}
              {["web-radio-tv", "web-tv-radio", "web-tv", "web-church-tv", "web-church-tv-radio"].includes(appData.type ?? '') && screens.tv()}
              {screens.news()}
              {screens.new()}
              {screens.others()}
              {screens.menu()}
              {screens.intro()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Colors;
